/**
 * This file contains hotfixes for the French version of the website. An example
 * of a hotfix is changing the text of a WooCommerce notice to French.
 */
export default function (): void {
	const replaceText = (selector: string, newText: string) => {
		const element = document.querySelector(selector) as HTMLElement;
		if (element) {
			element.innerHTML = newText;
		}
	};
	replaceText(
		".woocommerce-store-notice span",
		"<strong>Rappel :</strong> Nos bureaux seront <strong>fermés</strong> pour les vacances des fêtes du <strong>24 décembre 2022</strong> au <strong>2 janvier 2023</strong>.",
	);

	replaceText(".woocommerce-store-notice__dismiss-link", "cacher");
}
